<template>
  <b-form-group
    label="Choose geometry ID field"
    label-cols="3"
    :disabled="uploading"
  >
    <template slot="label">
      Choose geometry ID field<HelpTooltip title="The shapefile attribute that contains the geometry IDs" />
    </template>
    <b-select
      :value="value"
      :options="options"
      :state="state && null"
      @input="$emit('input', $event)"
    />
    <b-form-invalid-feedback :state="state && null">
      {{ invalidMessage }}
    </b-form-invalid-feedback>
    <slot name="warningmessage" />
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import HelpTooltip from '@/components/admin/upload/HelpTooltip.vue'

const components = {
  HelpTooltip,
}

const props = {
  v: {
    type: Object,
    required: true,
  },
  geom: {
    type: Object,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  uploading: {
    type: Boolean,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
}

@Component({ components })
export default class GeomIDs extends Vue.extend({ props }) {
  get state () {
    return this.v.$dirty ? !this.v.$error : null
  }

  get invalidMessage () {
    if (!this.v.required) {
      return 'This field is required'
    }
    if (!this.v.uniqueIDs) {
      return 'This field does not contain unique values. Please choose another field or change your shapefile and re-upload.'
    }
    if (!this.v.csvGeomIds) {
      return 'Some of the geometry IDs in your CSV are not present in this shapefile field. This means they will not show up on the map. Please choose another field or change your shapefile and/or CSV and re-upload.'
    }
    if (!this.v.unusedGeomIds) {
      return 'Some of the geometry IDs in your shapefile field are not used. This means they will not show up on the map.'
    }
    return null
  }
}

</script>
